import styles from "./RelatedListening.module.css";
import {
  catalogItemAnchorId,
  formatTypeLabel,
  getMetaSubtitle,
  scrollToCatalogItem,
} from "../../../Hooks/catalogPresentation";

const RelatedListening = ({ items = [], seedTitle = "" }) => {
  if (!items || items.length === 0) return null;

  const seedLabel = (seedTitle && String(seedTitle).trim()) || "this";
  const headingText = `More like ${seedLabel}`;

  return (
    <aside
      className={styles["related-root"]}
      aria-label={
        seedLabel !== "this"
          ? `More listening related to ${seedLabel}`
          : "More like this"
      }
    >
      <p className={styles["related-label"]} title={headingText}>
        <span className={styles["related-label-prefix"]}>More like&nbsp;</span>
        <span className={styles["related-label-title"]}>{seedLabel}</span>
      </p>
      <ul className={styles["related-list"]}>
        {items.map((item) => {
          const id = catalogItemAnchorId(item);
          const subtitle = getMetaSubtitle(item);
          const title = item.title || "Untitled";
          const metaLine = [formatTypeLabel(item.type), subtitle || ""]
            .filter(Boolean)
            .join(" · ");
          return (
            <li key={id || title} className={styles["related-item"]}>
              <button
                type="button"
                className={styles["related-button"]}
                onClick={() => scrollToCatalogItem(item)}
                title={metaLine ? `${title} — ${metaLine}` : title}
              >
                <span className={styles["related-title"]}>{title}</span>
                {/* {metaLine && (
                  <span className={styles["related-meta"]}>{metaLine}</span>
                )} */}
              </button>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default RelatedListening;
